<template>
	<div :class="{'flex-wrap': media, 'c-upload': !media, 'c-upload-media': media}">
		<template v-if="media">
			<div v-for="(item, i) in parseValueData" :key="i" class="c-upload-media-item flex-center" :class="{'c-upload-media-last': side && i == parseValueData.length - 1}">
				<c-file :src="item" media></c-file>
				<a class="flex-center" @click.stop="removeHandle(i)" @mousedown.stop><i class="c-icon-cross"></i></a>
			</div>
		</template>
		
		<div v-if="mediaUpload || side" class="flex-start-end" :class="{'c-upload-media-handle': media}">
			<div v-if="mediaUpload" slot="append" class="c-upload-media-item c-upload-media-upload flex-center" :warn="!!name && warnState" @click="uploadHandle">
				<i :class="mediaIcon"></i>
			</div>
			<div v-if="side" class="c-upload-handle" :class="{'flex-column': media, 'flex-end-start': media, 'flex-center-cross': !media}">
				<c-button size="upload" :prepend-icon="icon" hollow :warn="!!name && warnState" @click="uploadHandle">{{$t(button)}}</c-button>
				<div class="c-upload-tip">
					<slot v-if="$scopedSlots.tip" name="tip" :type="fileTypeTip"></slot>
					<p v-else>{{fileTypeTip}}</p>
				</div>
			</div>
		</div>
		
		<ul v-if="!media" v-show="parseValueData.length" class="c-upload-list">
			<li v-for="(item, i) in parseValueData" :key="i" class="flex-center-cross">
				<c-file class="ellipsis" :src="item"></c-file>
				<a class="c-upload-list-remove" @click="removeHandle(i)">{{$t('_t.upload.delete')}}</a>
			</li>
		</ul>
	</div>
</template>

<script>
	import {getStore, mapStore} from '@deanwu/vue-component-library-mobile'

	export default {
		name: 'cUploadFile',
		
		props: {
			value: {
				type: [String, Array],
				default: ''
			},
			
			name: [String, Number],
			
			type: String,
			
			size: [String, Number],
			
			media: Boolean,
			
			side: {
				type: Boolean,
				default: true
			},

			icon: {
				type: String,
				default: 'c-icon-upload'
			},

			mediaIcon: {
				type: String,
				default: 'c-icon-media'
			},
			
			button: {
				type: String,
				default: '_t.upload.button'
			},
			
			multiple: {
				type: [Boolean, Number, String],
				default: false
			},
			
			filePath: String
		},

		data() {
			return {
				...getStore(this, 'cFormStore'),
				...getStore(this, 'cFormItemStore'),
				valueData: this.multiple ? [] : ''
			}
		},

		computed: {
			...mapStore('cFormItemStore', ['warnState']),

			parseValueData: {
				get() {
					return this.valueData ? (typeof this.valueData == 'object' ? this.valueData : this.valueData.toString().split(',')) : []
				},
				
				set(val) {
					if (this.multiple) {
						this.valueData = val.join(',').split(',');
					}
				}
			},

			mediaUpload() {
				return this.media && (this.side ? !this.parseValueData.length : !this.upperLimit);
			},
			
			fileTypeTip() {
				let arr = [this.$t('_t.upload.type.any')];
				if (this.type) {
					arr = [];
					this.type.split(',').forEach(item => {
						arr = arr.concat(this.$compsConfig.config.file.acceptTip[item] || [item])
					});
				}
				return this.$t('_t.upload.tip', {type: arr.map(item => this.$t(item)).join('、')});
			},

			upperLimit() {
				return this.multiple
					? typeof this.multiple != 'boolean' && this.parseValueData.length >= parseInt(this.multiple)
					: this.parseValueData.length > 0;
			}
		},

		watch: {
			value(val) {
				this.set(val);
			},
			
			valueData() {
				this.$emit('input', this.get());
			}
		},
		
		mounted() {
			this.set(this.value);
		},
		
		methods: {
			set(val) {
				if (!val) val = this.multiple ? [] : '';
				if (this.multiple && typeof val == 'string') {
					val = val.split(',');
				}
				this.valueData = val;
				this.cFormItemStore && this.cFormItemStore.commit('warnState', false);
			},
			
			get() {
				return this.valueData;
			},
			
			removeHandle(i) {
				let data = this.parseValueData.join(',').split(',');
				data.splice(i, 1);
				this.set(this.multiple ? data : data.join(','));
				this.changeHandle();
			},

			uploadHandle() {
				this.cFormItemStore && this.cFormItemStore.commit('warnState', false);

				if (this.upperLimit && this.multiple) {
					this.$message({
						message: this.$t('_t.upload.message.limit', {limit: this.multiple})
					});
					return;
				}
				
				if (this._events.click) {
					this.$emit('click', {
						type: this.type,
						size: this.size,
						count: this.multiple ? typeof this.multiple != 'boolean' ? parseInt(this.multiple) - this.parseValueData.length : Infinity : 1,
						success: data => {
							if (!this.multiple) {
								this.set(data[0].path);
							} else {
								this.set(this.parseValueData.concat(Array.from(data, item => item.path)));
							}
							this.changeHandle();
						}
					});
				} else {
					this.uploadConfig({
						filePath: this.filePath
					});
					
					this.$compsConfig.config.file.fileEvent.call(this, {
						type: this.type,
						size: this.size,
						count: this.multiple ? typeof this.multiple != 'boolean' ? parseInt(this.multiple) - this.parseValueData.length : Infinity : 1,
						loading: true,
						success: data => {
							if (!this.multiple) {
								if (Array.isArray(data)) {
									data = data[0];
								}
								this.set(data.path);
							} else {
								this.set(this.parseValueData.concat(Array.from(data, item => item.path)));
							}
							this.changeHandle();
						}
					});
				}
			},

			changeHandle() {
				this.$emit('change', this.get());
				this.cFormStore && this.cFormStore.commit('editState', true);
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.c-upload {
		&-media {
			gap: .1rem;
			
			&-item {
				position: relative;
				background: #fff;
				
				a {
					position: absolute;
					right: .02rem;
					top: .02rem;
					width: .36rem;
					height: .36rem;
					font-size: .24rem;
					color: #fff;
					background: rgba(0,0,0,.4);
				}
			}

			&-last {
				margin-right: .1rem;
			}

			&-handle {
				gap: .2rem;

				.c-upload-handle {
					margin-top: .1rem;
				}
			}
				
			&-upload {
				box-sizing: border-box;
				min-width: 1.6rem;
				height: 1.6rem;
				border: .02rem solid var(--unit-border);
				font-size: .7rem;
				color: var(--unit-border);

				&[warn] {
					border-color: var(--unit-warn) !important;
				}
			}
		}

		&-handle {
			row-gap: .1rem;
			column-gap: .2rem;

			>>> .c-button {
				&[warn] {
					border-color: var(--unit-warn);
					color: var(--unit-warn);
				}
			}
		}
		
		&-tip {
			line-height: .36rem;
			font-size: .25rem;
			color: #999;
		}
		
		&-list {
			margin-top: .1rem;

			&-remove {
				margin-left: .2rem;
				font-size: .26rem;
				white-space: nowrap;
				color: #f00;
			}
		}
	}
</style>
